import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/nexus-utilities';
import { environment } from '@environments/environment';
import { ReprocessCommand, ReprocessCommandHistory } from '@app/models/commands/reprocess-command';

@Injectable({
  providedIn: 'root',
})
export class ReprocessProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.productionApi + '/api/v1/reprocess';

  reprocessProductionCard(command: ReprocessCommand): Observable<ApiResponse<ReprocessCommandHistory>> {
    return this.httpClient.post<ApiResponse<ReprocessCommandHistory>>(this.baseUrl, command);
  }
}
